import React, { useEffect } from "react";
import { FieldArray } from "formik";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../../partials/content/Forms/FormField";
import { Table } from "react-bootstrap";
import Illustration from "../../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../../partials/content/BootstrapTooltip";
import { InputAdornment } from "@material-ui/core";
const ItemsTransfer = ({
  values,
  onBlur,
  onChange,
  touched,
  errors,
  onOpenSearchStock,
  setFieldValue,
}) => {
  useEffect(() => {}, []);
  return (
    <React.Fragment>
      <FieldArray name="itemsTransfer">
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values.itemsTransfer && values.itemsTransfer.length > 0 ? (
                      <thead className="text-center">
                        <tr>
                          <th style={{ width: "40%" }}>Item Name</th>
                          <th style={{ width: "15%" }}>Quantity</th>
                          {values.transferToType !== 3 ? <th>Stock</th> : null}
                          <th style={{ width: "10%" }}>Batch</th>
                          <th style={{ width: "15%" }}>Unit</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                    ) : null}
                    <tbody>
                      {values.itemsTransfer &&
                      values.itemsTransfer.length > 0 ? (
                        values.itemsTransfer.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <FormOutlinedNoMarginTextField
                                  value={`${item.itemCode} ${item.itemName}`}
                                  InputProps={{
                                    startAdornment:
                                      item.itemType > 0 ? (
                                        <InputAdornment position="start">
                                          <BootstrapTooltip
                                            title={item.itemTypeName}
                                          >
                                            <i
                                              className={
                                                item.itemType === 1
                                                  ? "fas fa-boxes text-success"
                                                  : item.itemType === 2
                                                  ? "fas fa-tools text-primary"
                                                  : item.itemType === 3
                                                  ? "fas fa-building text-info"
                                                  : item.itemType === 4
                                                  ? "fas fa-boxes text-warning"
                                                  : item.itemType === 5
                                                  ? "fas fa-boxes text-danger"
                                                  : null
                                              }
                                            ></i>
                                          </BootstrapTooltip>
                                        </InputAdornment>
                                      ) : null,
                                    readOnly: true,
                                  }}
                                />
                              </td>
                              <td>
                                {item.itemsReservationID > 0 ? (
                                  <FormArrayTextField
                                    arrayPropName="itemsTransfer"
                                    index={index}
                                    propName="qty"
                                    quantityField
                                    margin="none"
                                    readonly
                                  />
                                ) : (
                                  <FormArrayTextField
                                    arrayPropName="itemsTransfer"
                                    index={index}
                                    propName="qty"
                                    quantityField
                                    margin="none"
                                    onBlur={(value) => {}}
                                  />
                                )}
                              </td>
                              {values.transferToType !== 3 ? (
                                <td>
                                  <FormArrayTextField
                                    arrayPropName="itemsTransfer"
                                    index={index}
                                    propName="qtyStock"
                                    margin="none"
                                    readonly
                                  />
                                </td>
                              ) : null}
                              <td>
                                <FormArrayTextField
                                  arrayPropName="itemsTransfer"
                                  index={index}
                                  propName="batchID"
                                  margin="none"
                                  readonly
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName="itemsTransfer"
                                  index={index}
                                  propName="uomName"
                                  margin="none"
                                  readonly
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center"
                              >
                                {values.transferToType !== 3 ? (
                                  <React.Fragment>
                                    {item.journeyStockID > 0 ? (
                                      <BootstrapTooltip
                                        title={
                                          item.delJourneyStock
                                            ? "Undo Delete"
                                            : "Delete Journey Stock Item"
                                        }
                                      >
                                        <button
                                          type="button"
                                          className={`btn btn-icon btn-label-${
                                            item.delJourneyStock
                                              ? "warning"
                                              : "danger"
                                          } btn-md btn-circle mx-1`}
                                          onClick={() => {
                                            setFieldValue(
                                              `itemsTransfer[${index}].delJourneyStock`,
                                              !item.delJourneyStock
                                            );
                                          }}
                                        >
                                          {item.delJourneyStock ? (
                                            <i className="fas fa-undo-alt"></i>
                                          ) : (
                                            <i className="fas fa-trash-alt"></i>
                                          )}
                                        </button>
                                      </BootstrapTooltip>
                                    ) : (
                                      <>
                                        {values.accessedFrom === "IND" ? (
                                          <BootstrapTooltip title="Delete Transfer Item">
                                            <button
                                              type="button"
                                              className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                              onClick={() => {
                                                remove(index);
                                              }}
                                            >
                                              <i className="fas fa-trash-alt"></i>
                                            </button>
                                          </BootstrapTooltip>
                                        ) : null}
                                      </>
                                    )}
                                  </React.Fragment>
                                ) : null}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            className="text-center py-3"
                            colSpan={`${
                              values.transferToType !== 3 ? "6" : "5"
                            }`}
                          >
                            <Illustration
                              imageSource="INVIFO Inventory.png"
                              guidance="You don't have any Transfer items yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              size="sm"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td
                          className="text-center py-3"
                          colSpan={`${values.transferToType !== 3 ? "6" : "5"}`}
                        >
                          {values.accessedFrom === "IND" ? (
                            <button
                              type="button"
                              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                              onClick={() => {
                                onOpenSearchStock(0);
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              Add Transfer Item
                            </button>
                          ) : null}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </FieldArray>
    </React.Fragment>
  );
};

export default ItemsTransfer;
